import { Form, message } from 'antd';
import React, { useEffect, useState } from 'react';

import CurrentImgTag from 'components/etc/CurrentImgTag';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneImage from 'components/dropzoneUpload/DropZoneImage';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';
import { platformImageUpdate } from 'apis/operation/platformImageApis';
import DefaultModal from 'components/modal/DefaultModal';
import SmallModal from 'components/form/SmallModal';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param {*} props
 * @returns 플랫폼 이미지(공용 이미지) 수정 모달
 */
const PlatformImgUpdateModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  record,
  setSelectDesignType,
}) => {
  const { t } = useTranslation();
  const [inputDatas, setInputDatas] = useState({
    image_name: '',
    design_id: -1,
    design_type: '',
    image_url: '',
  });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
  };

  /// 이미지 타입 드롭다운 이벤트
  const handleChangeDesignType = (value) => {
    setInputDatas({ ...inputDatas, design_type: value });
  };

  /// 이미지명 입력
  const handleInputName = (e) => {
    setInputDatas({ ...inputDatas, image_name: e.target.value });
  };

  /// 현재 이미지 닫기 => 드롭존으로 변환
  const handleCloseCurrentImg = () => {
    setInputDatas({ ...inputDatas, image_url: '' });
  };
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('design_id', inputDatas.design_id);
    formData.append('design_type', inputDatas.design_type);
    formData.append('image_name', inputDatas.image_name);

    const res = await platformImageUpdate(formData);
    console.log(res);
    // 목록 화면의 디자인 타입 셀렉 박스 값을 반영시킨다.
    fetchData(inputDatas.design_type);
    setSelectDesignType(inputDatas.design_type);
    setFile(null);
    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    setVisible(false);
    message.success(t('platformimg.createImageTypeModal.successMessage'), 1);
  };

  useEffect(() => {
    if (record) {
      setInputDatas({
        ...inputDatas,
        design_id: record.design_id,
        design_type: record.design_type,
        image_name: record.image_name,
        image_url: record.image_url,
      });
    }
  }, []);
  return (
    <SmallModal
      title={t('platformimg.createImageTypeModal.title')}
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop='true'>
        <Form.Item label={t('platformimg.createImageTypeModal.imageType')}>
          <DefaultSelect
            optionList={optionList}
            value={inputDatas.design_type}
            onChange={handleChangeDesignType}
          />
        </Form.Item>
        <Form.Item label={t('platformimg.createImageTypeModal.imageName')}>
          <DefaultInput
            maxLength={35}
            value={inputDatas.image_name}
            onChange={handleInputName}
          />
        </Form.Item>
        <Form.Item name='uploadFile'>
          {inputDatas?.image_url === '' ? (
            <DropZoneImage
              setFile={setFile}
              width={1620}
              height={1920}
              zipMemo='jpg, png'
            />
          ) : (
            <CurrentImgTag
              src={record?.image_url}
              text={record?.image_name}
              onClose={handleCloseCurrentImg}
            />
          )}
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>
          {t('platformimg.createImageTypeModal.register')}
        </SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformImgUpdateModal;
